var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_574",
    "data-name": "Groupe 574",
    transform: "translate(-72.475 -54)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(72.475 54)",
    fill: "#f8b6b6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CROIX",
    transform: "translate(-341.84 -221.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_631",
    "data-name": "Trac\\xE9 631",
    d: "M434.867,297.264a1.163,1.163,0,0,1-.827-.343l-12.146-12.189a1.166,1.166,0,0,1,1.652-1.646l12.147,12.189a1.166,1.166,0,0,1-.827,1.989Z",
    transform: "translate(0)",
    fill: "#db3b29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_632",
    "data-name": "Trac\\xE9 632",
    d: "M422.721,297.266a1.166,1.166,0,0,1-.824-1.992l12.187-12.146a1.166,1.166,0,0,1,1.648,1.651l-12.188,12.146A1.159,1.159,0,0,1,422.721,297.266Z",
    transform: "translate(0 -0.003)",
    fill: "#db3b29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSign);
export default __webpack_public_path__ + "static/media/errorSign.bd4836ab957690c04f3340a9e56cd421.svg";
export { ForwardRef as ReactComponent };